/**
 * Which build this page is running, and whether that is the one that is deployed.
 *
 * The app updates by being deployed over itself, and the service worker will serve the
 * last-known page when the network doesn't answer (frontend/src/sw.ts). Both are what
 * you want on a golf course; together they mean a phone can be showing a copy of the
 * app from before a fix, with nothing on screen to say so. Every "I merged it and it's
 * still broken" starts here, so the answer is made visible rather than deduced.
 */

declare const __BUILD__: string | undefined;

/** Stamped in at build time by build/build.mjs. "dev" when running unbundled. */
export const BUILD: string = typeof __BUILD__ === "string" ? __BUILD__ : "dev";
